import {observer} from "mobx-react";
import {useEffect, useState} from "react";
import {LoadingDotsComponent} from "../../../../../basic-components/loading-dots/loading-dots.component";
import {useServices} from "../../../../../react-hooks/use-services.hook";
import {OptInAccordionComponentBox} from "./boxes/opt-in-accordion-content.box";
import {JbTermsAndConditionsBox} from "./boxes/jb-terms-and-conditions.box";

export const OptInAccordionContentComponent: React.FC = observer((props) => {
    const services = useServices();
    const fileName = services.theme.currentTheme.assets.html.jb_t_and_c_html.toString();
    const [html, setHtml] = useState<string | null>(null);

    useEffect(() => {
        const loadHtml = async () => {
            try {
                const now = new Date();
                const antiCacheKey = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}-${now.getHours()}`;
                const url = `${fileName}?antiCacheKey=${antiCacheKey}`;

                const res = await fetch(url);
                if (!res.ok) throw new Error(`Failed to load HTML file. Status code: ${res.status}`);

                const data = await res.text();
                setHtml(data);
            } catch (err) {
                services.logger.error("Fetch error:", err);
                setHtml(null);
            }
        };

        loadHtml();
    }, [fileName, services.logger]);

    return (
        <OptInAccordionComponentBox>
            {html ? (
                <JbTermsAndConditionsBox dangerouslySetInnerHTML={{__html: html}} />
            ) : (
                <LoadingDotsComponent/>
            )}
        </OptInAccordionComponentBox>
    )
})